import {
    ChangeDetectionStrategy,
    Component,
    InputSignal,
    input
} from "@angular/core";
import {AbstractField} from "../field/abstract-field";
import {FormsModule, NG_VALUE_ACCESSOR} from "@angular/forms";
import {TranslateModule} from '@ngx-translate/core';
import {FieldComponent} from '../field/field.component';

@Component({
    selector: "woa-decimal-field",
    templateUrl: "./decimal-field.component.html",
    styleUrl: "./decimal-field.component.scss",
    providers: [{provide: NG_VALUE_ACCESSOR, useExisting: DecimalFieldComponent, multi: true}],
    imports: [
        FieldComponent,
        FormsModule,
        TranslateModule
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DecimalFieldComponent extends AbstractField {
    public readonly autocomplete: InputSignal<"username" | "one-time-code" | "cc-csc"> = input<"username" | "one-time-code" | "cc-csc">();
    public readonly maxlength: InputSignal<string> = input<string>();
    public readonly noMessage: InputSignal<boolean> = input<boolean>(false);

    DecimalFieldComponent = DecimalFieldComponent;

    public static validateCharacter(event: KeyboardEvent): void {
        if (["Enter", "Backspace", "ArrowLeft", "ArrowRight", "Tab", "0", "1", "2", "3", "4", "5", "6", "7", "8", "9"].indexOf(event.key) == -1) {
            event.preventDefault();
            event.stopPropagation();
        }
    }

    public static correctInput(event: KeyboardEvent): void {
        event.target["value"] = event.target["value"].replace(/\D/g, "");
    }
}
